export default "__VITE_ASSET__ByRPLqm___"